// Extracted from mud .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const MUD_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.25099999, 0.10590000, 0.01570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.07840000, 0.03920000, 0.01180000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const MUD_MESH_0: RuneMesh = {
  name: "Mud_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64279997, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.53810000, 0.43309999, 0.12169997,
    0.38859999, 0.43309999, -0.03120003,
    0.25529999, 0.43309999, -0.00570003,
    0.15760000, 0.43309999, 0.01299997,
    0.16100000, 0.43309999, -0.06510003,
    0.30370000, 0.43309996, -0.34710002,
    0.21200000, 0.43309996, -0.53730005,
    0.02520000, 0.43309996, -0.57810009,
    -0.16850001, 0.43309996, -0.57810009,
    -0.30770001, 0.43309996, -0.38780004,
    -0.12430000, 0.43309999, -0.06850003,
    -0.16170000, 0.43309999, -0.02100003,
    -0.34169999, 0.43309999, -0.06510003,
    -0.54890001, 0.43309999, 0.02659997,
    -0.58630002, 0.43310001, 0.26429996,
    -0.48440000, 0.43310001, 0.39679998,
    -0.29750001, 0.43310001, 0.45119998,
    -0.10730000, 0.43310001, 0.35269997,
    -0.02920000, 0.43310001, 0.21679997,
    0.12370000, 0.43310001, 0.40359998,
    0.26629999, 0.43310001, 0.49189997,
    0.46000001, 0.43310001, 0.47829998,
    0.53469998, 0.43310001, 0.31189996,
    0.72589999, 0.43310001, 0.32319996,
    0.64279997, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79019994,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91289997, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30410001, 0.24339992, -0.93610001,
    0.30410001, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30410001, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30410001, 0.18959993, -0.93610001,
    0.30410001, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91289997, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64279997, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64279997, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79020000,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 54, 55, 1, 54, 1, 0,
    1, 56, 57, 1, 57, 2, 3, 2, 58, 3, 58, 4,
    4, 58, 59, 4, 59, 5, 5, 59, 60, 5, 60, 6,
    6, 60, 61, 6, 61, 7, 7, 61, 62, 7, 62, 8,
    8, 62, 63, 8, 63, 9, 9, 63, 64, 9, 64, 10,
    10, 64, 65, 10, 65, 11, 11, 65, 66, 11, 66, 12,
    12, 66, 67, 12, 67, 13, 13, 67, 68, 13, 68, 14,
    14, 68, 69, 14, 69, 15, 15, 69, 70, 15, 70, 16,
    16, 70, 71, 16, 71, 17, 17, 71, 72, 17, 72, 18,
    18, 72, 73, 18, 73, 42, 42, 73, 74, 42, 74, 43,
    43, 74, 75, 43, 75, 44, 44, 75, 76, 44, 76, 45,
    45, 76, 77, 45, 77, 46, 46, 77, 78, 46, 78, 47,
    47, 78, 79, 47, 79, 48, 48, 79, 80, 48, 80, 49,
    49, 80, 81, 49, 81, 50, 50, 81, 82, 50, 82, 51,
    51, 82, 83, 51, 83, 52, 52, 83, 84, 52, 84, 53,
    53, 84, 55, 53, 55, 54, 55, 85, 56, 55, 56, 1,
    56, 86, 87, 56, 87, 57, 2, 57, 88, 2, 88, 58,
    58, 88, 89, 58, 89, 59, 59, 89, 90, 59, 90, 60,
    60, 90, 91, 60, 91, 61, 61, 91, 92, 61, 92, 62,
    62, 92, 93, 62, 93, 63, 63, 93, 94, 63, 94, 64,
    64, 94, 95, 64, 95, 65, 65, 95, 96, 65, 96, 66,
    66, 96, 97, 66, 97, 67, 67, 97, 98, 67, 98, 68,
    68, 98, 99, 68, 99, 69, 69, 99, 100, 69, 100, 70,
    70, 100, 101, 70, 101, 71, 71, 101, 102, 71, 102, 72,
    72, 102, 103, 72, 103, 73, 73, 103, 104, 73, 104, 74,
    74, 104, 105, 74, 105, 75, 75, 105, 106, 75, 106, 76,
    76, 106, 107, 76, 107, 77, 77, 107, 108, 77, 108, 78,
    78, 108, 109, 78, 109, 79, 79, 109, 110, 79, 110, 80,
    80, 110, 111, 80, 111, 81, 81, 111, 112, 81, 112, 82,
    82, 112, 113, 82, 113, 83, 83, 113, 114, 83, 114, 84,
    84, 114, 85, 84, 85, 55, 85, 115, 86, 85, 86, 56,
    86, 116, 117, 86, 117, 87, 57, 87, 118, 57, 118, 88,
    88, 118, 119, 88, 119, 89, 89, 119, 120, 89, 120, 90,
    90, 120, 121, 90, 121, 91, 91, 121, 122, 91, 122, 92,
    92, 122, 123, 92, 123, 93, 93, 123, 124, 93, 124, 94,
    94, 124, 125, 94, 125, 95, 95, 125, 126, 95, 126, 96,
    96, 126, 127, 96, 127, 97, 97, 127, 128, 97, 128, 98,
    98, 128, 129, 98, 129, 99, 99, 129, 130, 99, 130, 100,
    100, 130, 131, 100, 131, 101, 101, 131, 132, 101, 132, 102,
    102, 132, 133, 102, 133, 103, 103, 133, 134, 103, 134, 104,
    104, 134, 135, 104, 135, 105, 105, 135, 136, 105, 136, 106,
    106, 136, 137, 106, 137, 107, 107, 137, 138, 107, 138, 108,
    108, 138, 139, 108, 139, 109, 109, 139, 140, 109, 140, 110,
    110, 140, 141, 110, 141, 111, 111, 141, 142, 111, 142, 112,
    112, 142, 143, 112, 143, 113, 113, 143, 144, 113, 144, 114,
    114, 144, 115, 114, 115, 85, 115, 145, 116, 115, 116, 86,
    116, 146, 147, 116, 147, 117, 87, 117, 148, 87, 148, 118,
    118, 148, 149, 118, 149, 119, 119, 149, 150, 119, 150, 120,
    120, 150, 151, 120, 151, 121, 121, 151, 152, 121, 152, 122,
    122, 152, 153, 122, 153, 123, 123, 153, 154, 123, 154, 124,
    124, 154, 155, 124, 155, 125, 125, 155, 156, 125, 156, 126,
    126, 156, 157, 126, 157, 127, 127, 157, 158, 127, 158, 128,
    128, 158, 159, 128, 159, 129, 129, 159, 160, 129, 160, 130,
    130, 160, 161, 130, 161, 131, 131, 161, 162, 131, 162, 132,
    132, 162, 163, 132, 163, 133, 133, 163, 164, 133, 164, 134,
    134, 164, 165, 134, 165, 135, 135, 165, 166, 135, 166, 136,
    136, 166, 167, 136, 167, 137, 137, 167, 168, 137, 168, 138,
    138, 168, 169, 138, 169, 139, 139, 169, 170, 139, 170, 140,
    140, 170, 171, 140, 171, 141, 141, 171, 172, 141, 172, 142,
    142, 172, 173, 142, 173, 143, 143, 173, 174, 143, 174, 144,
    144, 174, 145, 144, 145, 115, 145, 175, 146, 145, 146, 116,
    146, 176, 177, 146, 177, 147, 117, 147, 178, 117, 178, 148,
    148, 178, 179, 148, 179, 149, 149, 179, 180, 149, 180, 150,
    150, 180, 181, 150, 181, 151, 151, 181, 182, 151, 182, 152,
    152, 182, 183, 152, 183, 153, 153, 183, 184, 153, 184, 154,
    154, 184, 185, 154, 185, 155, 155, 185, 186, 155, 186, 156,
    156, 186, 187, 156, 187, 157, 157, 187, 188, 157, 188, 158,
    158, 188, 189, 158, 189, 159, 159, 189, 190, 159, 190, 160,
    160, 190, 191, 160, 191, 161, 161, 191, 192, 161, 192, 162,
    162, 192, 193, 162, 193, 163, 163, 193, 194, 163, 194, 164,
    164, 194, 195, 164, 195, 165, 165, 195, 196, 165, 196, 166,
    166, 196, 197, 166, 197, 167, 167, 197, 198, 167, 198, 168,
    168, 198, 199, 168, 199, 169, 169, 199, 200, 169, 200, 170,
    170, 200, 201, 170, 201, 171, 171, 201, 202, 171, 202, 172,
    172, 202, 203, 172, 203, 173, 173, 203, 204, 173, 204, 174,
    174, 204, 175, 174, 175, 145, 175, 205, 176, 175, 176, 146,
    176, 208, 210, 176, 210, 177, 147, 177, 211, 147, 211, 178,
    178, 211, 212, 178, 212, 179, 179, 212, 213, 179, 213, 180,
    180, 213, 214, 180, 214, 181, 181, 214, 215, 181, 215, 182,
    182, 215, 216, 182, 216, 183, 183, 216, 217, 183, 217, 184,
    184, 217, 218, 184, 218, 185, 185, 218, 219, 185, 219, 186,
    186, 219, 220, 186, 220, 187, 187, 220, 221, 187, 221, 188,
    188, 221, 222, 188, 222, 189, 189, 222, 223, 189, 223, 190,
    190, 223, 224, 190, 224, 191, 191, 224, 225, 191, 225, 192,
    192, 225, 226, 192, 226, 193, 193, 226, 227, 193, 227, 194,
    194, 227, 228, 194, 228, 195, 195, 228, 229, 195, 229, 196,
    196, 229, 230, 196, 230, 197, 197, 230, 231, 197, 231, 198,
    198, 231, 232, 198, 232, 199, 199, 232, 233, 199, 233, 200,
    200, 233, 234, 200, 234, 201, 201, 234, 235, 201, 235, 202,
    202, 235, 236, 202, 236, 203, 203, 236, 237, 203, 237, 204,
    204, 237, 205, 204, 205, 175, 205, 239, 208, 205, 208, 176,
    206, 240, 242, 206, 242, 209, 177, 210, 244, 177, 244, 211,
    211, 244, 246, 211, 246, 212, 212, 246, 248, 212, 248, 213,
    213, 248, 250, 213, 250, 214, 214, 250, 252, 214, 252, 215,
    215, 252, 254, 215, 254, 216, 216, 254, 256, 216, 256, 217,
    217, 256, 258, 217, 258, 218, 218, 258, 259, 218, 259, 219,
    219, 259, 261, 219, 261, 220, 220, 261, 263, 220, 263, 221,
    221, 263, 265, 221, 265, 222, 222, 265, 267, 222, 267, 223,
    223, 267, 269, 223, 269, 224, 224, 269, 271, 224, 271, 225,
    225, 271, 273, 225, 273, 226, 226, 273, 275, 226, 275, 227,
    227, 275, 277, 227, 277, 228, 228, 277, 279, 228, 279, 229,
    229, 279, 281, 229, 281, 230, 230, 281, 283, 230, 283, 231,
    231, 283, 285, 231, 285, 232, 232, 285, 287, 232, 287, 233,
    233, 287, 289, 233, 289, 234, 234, 289, 291, 234, 291, 235,
    235, 291, 294, 235, 294, 236, 236, 294, 296, 236, 296, 237,
    237, 296, 239, 237, 239, 205, 238, 297, 241, 238, 241, 207,
    240, 298, 301, 240, 301, 242, 209, 242, 303, 209, 303, 243,
    243, 303, 304, 243, 304, 245, 245, 304, 305, 245, 305, 247,
    247, 305, 306, 247, 306, 249, 249, 306, 307, 249, 307, 251,
    251, 307, 308, 251, 308, 253, 253, 308, 309, 253, 309, 255,
    255, 309, 310, 255, 310, 257, 257, 310, 311, 257, 311, 260,
    260, 311, 312, 260, 312, 262, 262, 312, 313, 262, 313, 264,
    264, 313, 314, 264, 314, 266, 266, 314, 315, 266, 315, 268,
    268, 315, 316, 268, 316, 270, 270, 316, 317, 270, 317, 272,
    272, 317, 318, 272, 318, 274, 274, 318, 319, 274, 319, 276,
    276, 319, 320, 276, 320, 278, 278, 320, 321, 278, 321, 280,
    280, 321, 322, 280, 322, 282, 282, 322, 323, 282, 323, 284,
    284, 323, 324, 284, 324, 286, 286, 324, 325, 286, 325, 288,
    288, 325, 326, 288, 326, 290, 290, 326, 327, 290, 327, 292,
    292, 327, 328, 292, 328, 293, 293, 328, 329, 293, 329, 295,
    295, 329, 297, 295, 297, 238, 297, 330, 300, 297, 300, 241,
    299, 332, 333, 299, 333, 302, 242, 301, 334, 242, 334, 303,
    303, 334, 336, 303, 336, 304, 304, 336, 338, 304, 338, 305,
    305, 338, 340, 305, 340, 306, 306, 340, 342, 306, 342, 307,
    307, 342, 344, 307, 344, 308, 308, 344, 346, 308, 346, 309,
    309, 346, 348, 309, 348, 310, 310, 348, 351, 310, 351, 311,
    311, 351, 353, 311, 353, 312, 312, 353, 355, 312, 355, 313,
    313, 355, 357, 313, 357, 314, 314, 357, 359, 314, 359, 315,
    315, 359, 361, 315, 361, 316, 316, 361, 363, 316, 363, 317,
    317, 363, 365, 317, 365, 318, 318, 365, 367, 318, 367, 319,
    319, 367, 369, 319, 369, 320, 320, 369, 371, 320, 371, 321,
    321, 371, 373, 321, 373, 322, 322, 373, 375, 322, 375, 323,
    323, 375, 377, 323, 377, 324, 324, 377, 379, 324, 379, 325,
    325, 379, 381, 325, 381, 326, 326, 381, 383, 326, 383, 327,
    327, 383, 384, 327, 384, 328, 328, 384, 386, 328, 386, 329,
    329, 386, 330, 329, 330, 297, 331, 388, 332, 331, 332, 299,
    332, 389, 390, 332, 390, 333, 302, 333, 391, 302, 391, 335,
    335, 391, 392, 335, 392, 337, 337, 392, 393, 337, 393, 339,
    339, 393, 394, 339, 394, 341, 341, 394, 395, 341, 395, 343,
    343, 395, 396, 343, 396, 345, 345, 396, 397, 345, 397, 347,
    347, 397, 398, 347, 398, 349, 349, 398, 399, 349, 399, 350,
    350, 399, 400, 350, 400, 352, 352, 400, 401, 352, 401, 354,
    354, 401, 402, 354, 402, 356, 356, 402, 403, 356, 403, 358,
    358, 403, 404, 358, 404, 360, 360, 404, 405, 360, 405, 362,
    362, 405, 406, 362, 406, 364, 364, 406, 407, 364, 407, 366,
    366, 407, 408, 366, 408, 368, 368, 408, 409, 368, 409, 370,
    370, 409, 410, 370, 410, 372, 372, 410, 411, 372, 411, 374,
    374, 411, 412, 374, 412, 376, 376, 412, 413, 376, 413, 378,
    378, 413, 414, 378, 414, 380, 380, 414, 415, 380, 415, 382,
    382, 415, 416, 382, 416, 385, 385, 416, 417, 385, 417, 387,
    387, 417, 388, 387, 388, 331, 388, 418, 389, 388, 389, 332,
    389, 419, 420, 389, 420, 390, 333, 390, 421, 333, 421, 391,
    391, 421, 422, 391, 422, 392, 392, 422, 423, 392, 423, 393,
    393, 423, 424, 393, 424, 394, 394, 424, 425, 394, 425, 395,
    395, 425, 426, 395, 426, 396, 396, 426, 427, 396, 427, 397,
    397, 427, 428, 397, 428, 398, 398, 428, 429, 398, 429, 399,
    399, 429, 430, 399, 430, 400, 400, 430, 431, 400, 431, 401,
    401, 431, 432, 401, 432, 402, 402, 432, 433, 402, 433, 403,
    403, 433, 434, 403, 434, 404, 404, 434, 435, 404, 435, 405,
    405, 435, 436, 405, 436, 406, 406, 436, 437, 406, 437, 407,
    407, 437, 438, 407, 438, 408, 408, 438, 439, 408, 439, 409,
    409, 439, 440, 409, 440, 410, 410, 440, 441, 410, 441, 411,
    411, 441, 442, 411, 442, 412, 412, 442, 443, 412, 443, 413,
    413, 443, 444, 413, 444, 414, 414, 444, 445, 414, 445, 415,
    415, 445, 446, 415, 446, 416, 416, 446, 447, 416, 447, 417,
    417, 447, 418, 417, 418, 388, 418, 448, 419, 418, 419, 389,
    419, 449, 450, 419, 450, 420, 390, 420, 451, 390, 451, 421,
    421, 451, 452, 421, 452, 422, 422, 452, 453, 422, 453, 423,
    423, 453, 454, 423, 454, 424, 424, 454, 455, 424, 455, 425,
    425, 455, 456, 425, 456, 426, 426, 456, 457, 426, 457, 427,
    427, 457, 458, 427, 458, 428, 428, 458, 459, 428, 459, 429,
    429, 459, 460, 429, 460, 430, 430, 460, 461, 430, 461, 431,
    431, 461, 462, 431, 462, 432, 432, 462, 463, 432, 463, 433,
    433, 463, 464, 433, 464, 434, 434, 464, 465, 434, 465, 435,
    435, 465, 466, 435, 466, 436, 436, 466, 467, 436, 467, 437,
    437, 467, 468, 437, 468, 438, 438, 468, 469, 438, 469, 439,
    439, 469, 470, 439, 470, 440, 440, 470, 471, 440, 471, 441,
    441, 471, 472, 441, 472, 442, 442, 472, 473, 442, 473, 443,
    443, 473, 474, 443, 474, 444, 444, 474, 475, 444, 475, 445,
    445, 475, 476, 445, 476, 446, 446, 476, 477, 446, 477, 447,
    447, 477, 448, 447, 448, 418, 448, 478, 449, 448, 449, 419,
    449, 479, 480, 449, 480, 450, 420, 450, 481, 420, 481, 451,
    451, 481, 482, 451, 482, 452, 452, 482, 483, 452, 483, 453,
    453, 483, 484, 453, 484, 454, 454, 484, 485, 454, 485, 455,
    455, 485, 486, 455, 486, 456, 456, 486, 487, 456, 487, 457,
    457, 487, 488, 457, 488, 458, 458, 488, 489, 458, 489, 459,
    459, 489, 490, 459, 490, 460, 460, 490, 491, 460, 491, 461,
    461, 491, 492, 461, 492, 462, 462, 492, 493, 462, 493, 463,
    463, 493, 494, 463, 494, 464, 464, 494, 495, 464, 495, 465,
    465, 495, 496, 465, 496, 466, 466, 496, 497, 466, 497, 467,
    467, 497, 498, 467, 498, 468, 468, 498, 499, 468, 499, 469,
    469, 499, 500, 469, 500, 470, 470, 500, 501, 470, 501, 471,
    471, 501, 502, 471, 502, 472, 472, 502, 503, 472, 503, 473,
    473, 503, 504, 473, 504, 474, 474, 504, 505, 474, 505, 475,
    475, 505, 506, 475, 506, 476, 476, 506, 507, 476, 507, 477,
    477, 507, 478, 477, 478, 448, 478, 508, 479, 478, 479, 449,
    479, 509, 510, 479, 510, 480, 450, 480, 511, 450, 511, 481,
    481, 511, 512, 481, 512, 482, 482, 512, 513, 482, 513, 483,
    483, 513, 514, 483, 514, 484, 484, 514, 515, 484, 515, 485,
    485, 515, 516, 485, 516, 486, 486, 516, 517, 486, 517, 487,
    487, 517, 518, 487, 518, 488, 488, 518, 519, 488, 519, 489,
    489, 519, 520, 489, 520, 490, 490, 520, 521, 490, 521, 491,
    491, 521, 522, 491, 522, 492, 492, 522, 523, 492, 523, 493,
    493, 523, 524, 493, 524, 494, 494, 524, 525, 494, 525, 495,
    495, 525, 526, 495, 526, 496, 496, 526, 527, 496, 527, 497,
    497, 527, 528, 497, 528, 498, 498, 528, 529, 498, 529, 499,
    499, 529, 530, 499, 530, 500, 500, 530, 531, 500, 531, 501,
    501, 531, 532, 501, 532, 502, 502, 532, 533, 502, 533, 503,
    503, 533, 534, 503, 534, 504, 504, 534, 535, 504, 535, 505,
    505, 535, 536, 505, 536, 506, 506, 536, 537, 506, 537, 507,
    507, 537, 508, 507, 508, 478, 508, 538, 509, 508, 509, 479,
    509, 539, 540, 509, 540, 510, 480, 510, 541, 480, 541, 511,
    511, 541, 542, 511, 542, 512, 512, 542, 543, 512, 543, 513,
    513, 543, 544, 513, 544, 514, 514, 544, 545, 514, 545, 515,
    515, 545, 546, 515, 546, 516, 516, 546, 547, 516, 547, 517,
    517, 547, 548, 517, 548, 518, 518, 548, 549, 518, 549, 519,
    519, 549, 550, 519, 550, 520, 520, 550, 551, 520, 551, 521,
    521, 551, 552, 521, 552, 522, 522, 552, 553, 522, 553, 523,
    523, 553, 554, 523, 554, 524, 524, 554, 555, 524, 555, 525,
    525, 555, 556, 525, 556, 526, 526, 556, 557, 526, 557, 527,
    527, 557, 558, 527, 558, 528, 528, 558, 559, 528, 559, 529,
    529, 559, 560, 529, 560, 530, 530, 560, 561, 530, 561, 531,
    531, 561, 562, 531, 562, 532, 532, 562, 563, 532, 563, 533,
    533, 563, 564, 533, 564, 534, 534, 564, 565, 534, 565, 535,
    535, 565, 566, 535, 566, 536, 536, 566, 567, 536, 567, 537,
    537, 567, 538, 537, 538, 508, 538, 568, 539, 538, 539, 509,
    539, 569, 540, 510, 540, 570, 510, 570, 541, 541, 570, 571,
    541, 571, 542, 542, 571, 572, 542, 572, 543, 543, 572, 573,
    543, 573, 544, 544, 573, 574, 544, 574, 545, 545, 574, 575,
    545, 575, 546, 546, 575, 576, 546, 576, 547, 547, 576, 577,
    547, 577, 548, 548, 577, 578, 548, 578, 549, 549, 578, 579,
    549, 579, 550, 550, 579, 580, 550, 580, 551, 551, 580, 581,
    551, 581, 552, 552, 581, 582, 552, 582, 553, 553, 582, 583,
    553, 583, 554, 554, 583, 584, 554, 584, 555, 555, 584, 585,
    555, 585, 556, 556, 585, 586, 556, 586, 557, 557, 586, 587,
    557, 587, 558, 558, 587, 588, 558, 588, 559, 559, 588, 589,
    559, 589, 560, 560, 589, 590, 560, 590, 561, 561, 590, 591,
    561, 591, 562, 562, 591, 592, 562, 592, 563, 563, 592, 593,
    563, 593, 564, 564, 593, 594, 564, 594, 565, 565, 594, 595,
    565, 595, 566, 566, 595, 596, 566, 596, 567, 567, 596, 568,
    567, 568, 538, 568, 569, 539, 540, 569, 570, 570, 569, 571,
    571, 569, 572, 572, 569, 573, 573, 569, 574, 574, 569, 575,
    575, 569, 576, 576, 569, 577, 577, 569, 578, 578, 569, 579,
    579, 569, 580, 580, 569, 581, 581, 569, 582, 582, 569, 583,
    583, 569, 584, 584, 569, 585, 585, 569, 586, 586, 569, 587,
    587, 569, 588, 588, 569, 589, 589, 569, 590, 590, 569, 591,
    591, 569, 592, 592, 569, 593, 593, 569, 594, 594, 569, 595,
    595, 569, 596, 596, 569, 568, 16, 17, 18, 18, 19, 20,
    21, 22, 23, 16, 18, 20, 20, 21, 23, 20, 23, 24,
    15, 16, 20, 13, 14, 15, 11, 12, 13, 9, 10, 11,
    7, 8, 9, 5, 6, 7, 31, 4, 5, 29, 30, 31,
    28, 29, 31, 31, 5, 7, 7, 9, 11, 11, 13, 15,
    15, 20, 24, 15, 24, 25, 28, 31, 7, 27, 28, 7,
    11, 15, 25, 26, 27, 7, 11, 25, 26, 26, 7, 11,
    45, 46, 47, 47, 48, 49, 49, 50, 51, 51, 52, 53,
    53, 54, 0, 0, 3, 4, 4, 31, 32, 4, 32, 33,
    53, 0, 4, 49, 51, 53, 45, 47, 49, 43, 44, 45,
    18, 42, 43, 41, 19, 18, 40, 41, 18, 18, 43, 45,
    45, 49, 53, 53, 4, 33, 53, 33, 34, 40, 18, 45,
    39, 40, 45, 45, 53, 34, 45, 34, 35, 38, 39, 45,
    36, 37, 38, 45, 35, 36, 36, 38, 45,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05790270, 0.99824645, 0.01230057,
    -0.19930776, 0.97783807, 0.06410249,
    -0.20059366, -0.22079301, 0.95446982,
    0.08190164, 0.89981804, 0.42850860,
    -0.53900219, 0.56610228, 0.62370254,
    -0.72458841, 0.66258933, -0.18959697,
    -0.97590370, -0.20660079, 0.07020027,
    -0.59347274, -0.18559146, 0.78316404,
    -0.09800329, -0.25810867, 0.96113228,
    0.43380063, -0.20490029, 0.87740121,
    0.97005005, -0.19190990, 0.14890768,
    0.59521134, 0.80281528, 0.03480066,
    0.12490031, 0.76640191, 0.63010159,
    0.14290749, -0.35611866, 0.92344840,
    0.80162940, -0.29171070, 0.52181910,
    0.92172479, -0.24420657, -0.30130809,
    0.58049483, -0.25259775, -0.77409310,
    -0.04509922, -0.27709520, -0.95978347,
    -0.60261539, -0.32440828, -0.72911862,
    -0.06549784, 0.88247082, -0.46578459,
    0.54522164, -0.36381445, -0.75523003,
    0.13369744, -0.32249381, -0.93708203,
    -0.60541266, -0.20960438, -0.76781607,
    -0.92668207, -0.29219435, -0.23639542,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43951681, 0.89823436, 0.00000000,
    -0.42999631, 0.89819227, -0.09139921,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15369423, 0.97326347, -0.17069359,
    0.18590659, 0.97323452, -0.13510480,
    0.20960329, 0.97331528, -0.09340147,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20950964, 0.97334476, 0.09330429,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399934, 0.97327301, 0.22839368,
    -0.02399988, 0.97329524, 0.22829889,
    -0.07099969, 0.97329573, 0.21829904,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43007782, 0.89815365, 0.09139528,
    -0.62772702, 0.77843355, 0.00000000,
    -0.61396481, 0.77845540, -0.13059251,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61423280, 0.77824154, 0.13060698,
    -0.78468818, 0.61989069, 0.00000000,
    -0.76752538, 0.61992050, -0.16310540,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76752538, 0.61992050, 0.16310540,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189903, 0.22119788, -0.96989076,
    0.30138787, 0.22089110, -0.92756265,
    0.48760288, 0.22110131, -0.84460502,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439560, 0.05599764, -0.99295812,
    0.10439560, 0.05599764, -0.99295812,
    0.30849597, 0.05579927, -0.94958764,
    0.30849597, 0.05579927, -0.94958764,
    0.49918934, 0.05599880, -0.86468152,
    0.49918934, 0.05599880, -0.86468152,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50001101, 0.00000000, -0.86601905,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439560, -0.05599764, -0.99295812,
    0.10439560, -0.05599764, -0.99295812,
    0.30849597, -0.05579927, -0.94958764,
    0.30849597, -0.05579927, -0.94958764,
    0.49918934, -0.05599880, -0.86468152,
    0.49918934, -0.05599880, -0.86468152,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30139453, -0.22079598, -0.92758314,
    0.48760288, -0.22110131, -0.84460502,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76752538, -0.61992050, -0.16310540,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76752538, -0.61992050, 0.16310540,
    -0.62772702, -0.77843355, 0.00000000,
    -0.61423280, -0.77824154, -0.13060698,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61423280, -0.77824154, 0.13060698,
    -0.43951681, -0.89823436, 0.00000000,
    -0.42999631, -0.89819227, -0.09139921,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.42999631, -0.89819227, 0.09139921,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15369423, -0.97326347, -0.17069359,
    0.18590659, -0.97323452, -0.13510480,
    0.20950964, -0.97334476, -0.09330429,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20950964, -0.97334476, 0.09330429,
    0.18590659, -0.97323452, 0.13510480,
    0.15369423, -0.97326347, 0.17069359,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399934, -0.97327301, 0.22839368,
    -0.02399988, -0.97329524, 0.22829889,
    -0.07099969, -0.97329573, 0.21829904,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04019983, -0.99819579, -0.04459981,
    0.04850013, -0.99820273, -0.03520010,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04850013, -0.99820273, 0.03520010,
    0.04009999, -0.99819980, 0.04459999,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630002, -0.99820245, 0.05960015,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01850016, -0.99820844, 0.05690048,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
  ]),
  materialIndex: 0,
};

const MUD_MESH_1: RuneMesh = {
  name: "Mud_Rune_primitive1",
  positions: new Float32Array([
    0.53810000, 0.43309999, 0.12169997,
    0.38859999, 0.43309999, -0.03120003,
    0.25529999, 0.43309999, -0.00570003,
    0.15760000, 0.43309999, 0.01299997,
    0.16100000, 0.43309999, -0.06510003,
    0.30370000, 0.43309996, -0.34710002,
    0.21200000, 0.43309996, -0.53730005,
    0.02520000, 0.43309996, -0.57810009,
    0.02520000, 0.43309996, -0.57810009,
    -0.16850001, 0.43309996, -0.57810009,
    -0.30770001, 0.43309996, -0.38780004,
    -0.30770001, 0.43309996, -0.38780004,
    -0.12430000, 0.43309999, -0.06850003,
    -0.16170000, 0.43309999, -0.02100003,
    -0.34169999, 0.43309999, -0.06510003,
    -0.54890001, 0.43309999, 0.02659997,
    -0.58630002, 0.43310001, 0.26429996,
    -0.48440000, 0.43310001, 0.39679998,
    -0.29750001, 0.43310001, 0.45119998,
    -0.10730000, 0.43310001, 0.35269997,
    -0.02920000, 0.43310001, 0.21679997,
    0.12370000, 0.43310001, 0.40359998,
    0.12370000, 0.43310001, 0.40359998,
    0.26629999, 0.43310001, 0.49189997,
    0.46000001, 0.43310001, 0.47829998,
    0.46000001, 0.43310001, 0.47829998,
    0.53469998, 0.43310001, 0.31189996,
    0.41920000, 0.34720001, 0.11489997,
    0.26969999, 0.34720001, 0.06049997,
    0.15760000, 0.37059999, 0.01299997,
    0.15760000, 0.37059999, 0.01299997,
    0.16100000, 0.37059999, -0.06510003,
    0.11350000, 0.34720001, -0.10590003,
    0.15760000, 0.34719998, -0.27910003,
    0.12030000, 0.34719998, -0.39120004,
    0.02520000, 0.34719998, -0.43880004,
    -0.10730000, 0.34719998, -0.43880004,
    -0.16170000, 0.34719998, -0.30630004,
    -0.07000000, 0.34720001, -0.06170003,
    -0.11750000, 0.34720001, 0.01299997,
    -0.11750000, 0.34720001, 0.01299997,
    -0.29069999, 0.34720001, 0.00279997,
    -0.45039999, 0.34720001, 0.04699997,
    -0.48100001, 0.34720001, 0.18279997,
    -0.37909999, 0.34720004, 0.31869996,
    -0.27039999, 0.34720004, 0.34249997,
    -0.12090000, 0.34720004, 0.24739997,
    -0.03260000, 0.34720001, 0.10469997,
    0.04550000, 0.34720004, 0.24739997,
    0.20520000, 0.34720004, 0.39339998,
    0.20520000, 0.34720004, 0.39339998,
    0.34450001, 0.34720004, 0.38659996,
    0.43619999, 0.34720004, 0.25079998,
    0.02860000, 0.34720001, -0.02780003,
    0.04210000, 0.34720001, 0.03339997,
  ]),
  indices: new Uint16Array([
    28, 30, 3, 28, 3, 2, 1, 0, 27, 2, 1, 27,
    2, 27, 28, 4, 3, 29, 4, 29, 31, 33, 5, 4,
    4, 31, 32, 4, 32, 33, 6, 5, 33, 6, 33, 34,
    8, 6, 34, 8, 34, 35, 9, 7, 35, 9, 35, 36,
    10, 9, 36, 10, 36, 37, 12, 11, 37, 12, 37, 38,
    13, 12, 38, 13, 38, 39, 14, 13, 40, 14, 40, 41,
    15, 14, 41, 15, 41, 42, 16, 15, 42, 16, 42, 43,
    17, 16, 43, 17, 43, 44, 18, 17, 44, 18, 44, 45,
    19, 18, 45, 19, 45, 46, 20, 19, 46, 20, 46, 47,
    22, 20, 47, 22, 47, 48, 23, 21, 48, 23, 48, 50,
    25, 23, 49, 25, 49, 51, 26, 24, 51, 26, 51, 52,
    0, 26, 52, 0, 52, 27, 31, 53, 32, 30, 28, 54,
    31, 30, 54, 31, 54, 53,
  ]),
  normals: new Float32Array([
    -0.19930776, 0.97783807, 0.06410249,
    -0.20059366, -0.22079301, 0.95446982,
    0.08190164, 0.89981804, 0.42850860,
    -0.53900219, 0.56610228, 0.62370254,
    -0.72458841, 0.66258933, -0.18959697,
    -0.97590370, -0.20660079, 0.07020027,
    -0.59347274, -0.18559146, 0.78316404,
    -0.09800329, -0.25810867, 0.96113228,
    -0.09810234, -0.25810614, 0.96112286,
    0.43380063, -0.20490029, 0.87740121,
    0.97003143, -0.19200622, 0.14890482,
    0.97001698, -0.19200336, 0.14900261,
    0.59521134, 0.80281528, 0.03480066,
    0.12490031, 0.76640191, 0.63010159,
    0.14290241, -0.35620601, 0.92341550,
    0.80162940, -0.29171070, 0.52181910,
    0.92176233, -0.24409002, -0.30128768,
    0.58049483, -0.25259775, -0.77409310,
    -0.04509922, -0.27709520, -0.95978347,
    -0.60263493, -0.32431881, -0.72914227,
    -0.06549784, 0.88247082, -0.46578459,
    0.54522164, -0.36381445, -0.75523003,
    0.54518050, -0.36378696, -0.75527298,
    0.13370175, -0.32240423, -0.93711224,
    -0.60542539, -0.20950877, -0.76783213,
    -0.60548871, -0.20949611, -0.76778565,
    -0.92668207, -0.29219435, -0.23639542,
    -0.32341296, 0.91113647, 0.25541023,
    -0.14329821, 0.87888896, 0.45499432,
    -0.50387689, 0.68246872, 0.52947571,
    -0.50390357, 0.68250484, 0.52940375,
    -0.80410521, 0.52500342, 0.27890181,
    -0.18740772, 0.97694022, -0.10230422,
    -0.31100200, 0.95030614, -0.01400009,
    -0.24410485, 0.95391895, 0.17450347,
    -0.08390267, 0.94813016, 0.30660976,
    0.22231033, 0.93724355, 0.26861245,
    0.33671227, 0.94063429, -0.04280156,
    0.91158123, -0.39939178, 0.09749799,
    0.46630847, -0.40060726, 0.78871429,
    0.46619341, -0.40059433, 0.78878887,
    0.02909841, 0.88735136, 0.46017481,
    0.30060444, 0.85141262, 0.42980637,
    0.39869625, 0.91669137, -0.02679975,
    0.17120000, 0.92899998, -0.32809998,
    -0.12030388, 0.90392917, -0.41041324,
    -0.34600657, 0.89241700, -0.28960552,
    0.01109958, -0.22729149, -0.97376351,
    0.58078744, 0.73228414, -0.35559232,
    0.30361622, 0.81664363, -0.49082621,
    0.30359143, 0.81667693, -0.49078614,
    -0.13220152, 0.92991065, -0.34320393,
    -0.39120292, 0.91820685, -0.06210046,
    -0.98152133, -0.07270158, -0.17700384,
    -0.77679660, -0.08419964, 0.62409732,
  ]),
  materialIndex: 1,
};

const MUD_MESH_2: RuneMesh = {
  name: "Mud_Rune_primitive2",
  positions: new Float32Array([
    0.41920000, 0.34720001, 0.11489997,
    0.26969999, 0.34720001, 0.06049997,
    0.11350000, 0.34720001, -0.10590003,
    0.15760000, 0.34719998, -0.27910003,
    0.12030000, 0.34719998, -0.39120004,
    0.02520000, 0.34719998, -0.43880004,
    -0.10730000, 0.34719998, -0.43880004,
    -0.16170000, 0.34719998, -0.30630004,
    -0.07000000, 0.34720001, -0.06170003,
    -0.11750000, 0.34720001, 0.01299997,
    -0.29069999, 0.34720001, 0.00279997,
    -0.45039999, 0.34720001, 0.04699997,
    -0.48100001, 0.34720001, 0.18279997,
    -0.37909999, 0.34720004, 0.31869996,
    -0.27039999, 0.34720004, 0.34249997,
    -0.12090000, 0.34720004, 0.24739997,
    -0.03260000, 0.34720001, 0.10469997,
    0.04550000, 0.34720004, 0.24739997,
    0.20520000, 0.34720004, 0.39339998,
    0.34450001, 0.34720004, 0.38659996,
    0.43619999, 0.34720004, 0.25079998,
    0.02860000, 0.34720001, -0.02780003,
    0.04210000, 0.34720001, 0.03339997,
  ]),
  indices: new Uint16Array([
    18, 17, 16, 16, 15, 14, 14, 13, 12, 12, 11, 10,
    12, 10, 9, 16, 14, 12, 19, 18, 16, 0, 20, 19,
    22, 1, 0, 3, 2, 21, 22, 0, 19, 4, 3, 21,
    22, 19, 16, 5, 4, 21, 21, 22, 16, 16, 12, 9,
    8, 7, 6, 16, 9, 8, 5, 21, 16, 8, 6, 5,
    16, 8, 5,
  ]),
  normals: new Float32Array([
    -0.32341296, 0.91113647, 0.25541023,
    -0.14329821, 0.87888896, 0.45499432,
    -0.18740772, 0.97694022, -0.10230422,
    -0.31100200, 0.95030614, -0.01400009,
    -0.24410485, 0.95391895, 0.17450347,
    -0.08390267, 0.94813016, 0.30660976,
    0.22228948, 0.93725570, 0.26858729,
    0.33671227, 0.94063429, -0.04280156,
    0.91158123, -0.39939178, 0.09749799,
    0.46630847, -0.40060726, 0.78871429,
    0.02910099, 0.88733010, 0.46021562,
    0.30060444, 0.85141262, 0.42980637,
    0.39869625, 0.91669137, -0.02679975,
    0.17120000, 0.92899998, -0.32809998,
    -0.12030388, 0.90392917, -0.41041324,
    -0.34600657, 0.89241700, -0.28960552,
    0.01109984, -0.22719665, -0.97378564,
    0.58078744, 0.73228414, -0.35559232,
    0.30361622, 0.81664363, -0.49082621,
    -0.13220152, 0.92991065, -0.34320393,
    -0.39120292, 0.91820685, -0.06210046,
    -0.98153870, -0.07270286, -0.17690697,
    -0.77679660, -0.08419964, 0.62409732,
  ]),
  materialIndex: 2,
};

export const MUD_MESHES: RuneMesh[] = [
  MUD_MESH_0,
  MUD_MESH_1,
  MUD_MESH_2,
];
